import React from 'react'
import _ from 'underscore'
import { ChevronsDownUp, ChevronsUpDown, Send } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  Card,
  CardAction,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import PendingTutorProposalsPartial from './partial'
import store from '../../../../../../state/store'

class PendingTutorProposals extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      notify_via_sms: true,
      notify_via_mail: true,
      conceal_job_ad: false,
      expanded: true
    }
  }

  onNotifyViaSmsChange = () => {
    this.setState({notify_via_sms: !this.state.notify_via_sms})
  }

  onNotifyViaMailChange = () => {
    this.setState({notify_via_mail: !this.state.notify_via_mail})
  }

  onToggleProposals = () => {
    this.setState({expanded: !this.state.expanded})
  }

  onPropose = () => {
    const params = {
      tutoring_job_id: this.props.tutoring_job_id,
      tutor_proposals: this.props.tutor_proposals,
      notify_via_sms: this.state.notify_via_sms,
      notify_via_mail: this.state.notify_via_mail,
      conceal_job_ad: this.state.conceal_job_ad
    }

    store.emit('tutor_selection:create', params)
  }

  render() {
    const grouped_tutor_proposals = _.groupBy(this.props.tutor_proposals, function(tutor_proposal) {
      return tutor_proposal.tutor.id
    })

    return (
      <Card size="sm" className="fixed bottom-4 right-7 z-[3000] min-w-[350px] shadow-lg">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Send className="size-4"/>
            Propose Tutors
          </CardTitle>
          <CardAction className="ml-auto self-center">
            <Button variant="ghost" size="icon-sm" onClick={this.onToggleProposals} aria-label={this.state.expanded ? 'Collapse proposals' : 'Expand proposals'}>
              {this.state.expanded ?
                <ChevronsDownUp className="size-4"/>
              :
                <ChevronsUpDown className="size-4"/>
              }
            </Button>
          </CardAction>
        </CardHeader>
        {this.state.expanded ?
          <React.Fragment>
            <CardContent className="divide-y divide-border">
              {_.map(_.keys(grouped_tutor_proposals), (tutor_id) => {
                const tutor_proposal = _.first(grouped_tutor_proposals[tutor_id])
                const tutor = tutor_proposal.tutor

                const tutoring_job_position_names = _.map(grouped_tutor_proposals[tutor_id], function(tutor_proposal) {
                  if (tutor_proposal.motivation.length > 5)
                    return (
                      <label key={tutor_proposal.tutoring_job_position.subject_name}>{tutor_proposal.tutoring_job_position.subject_name}</label>
                    )
                  else
                    return (
                      <label key={tutor_proposal.tutoring_job_position.subject_name}>{tutor_proposal.tutoring_job_position.subject_name} <Badge variant="warning">No Motivation</Badge></label>
                    )
                })

                return (
                  <PendingTutorProposalsPartial
                    key={tutor_id}
                    tutor={tutor}
                    tutoring_job_position_names={tutoring_job_position_names}
                  />
                )
              })}
            </CardContent>
            <CardFooter className="justify-between border-t">
              <div className="flex items-center gap-2">
                <Checkbox
                  id="proposal_conceal_job_ad"
                  checked={this.state.conceal_job_ad}
                  onCheckedChange={(checked) => this.setState({ conceal_job_ad: checked === true })}
                />
                <Label htmlFor="proposal_conceal_job_ad" className="text-sm font-normal">
                  Turn off the Job Ad
                </Label>
              </div>
              <Button size="sm" onClick={this.onPropose}>
                Send Proposals
              </Button>
            </CardFooter>
          </React.Fragment>
          : null
        }
      </Card>
    )
  }
}

export default PendingTutorProposals
